import { MAIN_CIAN_LINK } from 'shared/constants/links';
import { NBSP } from 'shared/constants/symbols';

export const DESCRIPTION = [
  [
    { value: 'Циан', url: MAIN_CIAN_LINK, isBold: true },
    {
      value: ` — это не${NBSP}просто платформа с${NBSP}объявлениями, а${NBSP}система сервисов, которая охватывает все${NBSP}ключевые этапы пути пользователя на${NBSP}рынке недвижимости.`,
      isBold: true,
    },
  ],
  [
    {
      value: `Мы${NBSP}развиваем решения, которые делают операции с${NBSP}недвижимостью проще, быстрее и${NBSP}прозрачнее${NBSP}— от${NBSP}поиска и${NBSP}оценки объектов до${NBSP}оформления сделки онлайн.`,
      isBold: true,
    },
  ],
  [
    {
      value: `Разнообразие направлений бизнеса${NBSP}— от${NBSP}основного классифайда до${NBSP}финансовых и${NBSP}сервисных инструментов${NBSP}— позволяет нам сохранять устойчивость и${NBSP}развиваться вне зависимости от${NBSP}рыночных${NBSP}циклов.`,
      isBold: true,
    },
  ],
];
